import request from "@/util/http";
import qs from "qs"; // 主题列表查询

export var getTopicList = function getTopicList(params) {
  return request({
    url: "/admin/topic/page",
    method: "get",
    params: params
  });
}; // 专题单个删除

export var handleTopicDelete = function handleTopicDelete(id) {
  return request({
    url: "/admin/topic/delete/".concat(id),
    method: "delete"
  });
}; // 专题信息

export var getTopicInfo = function getTopicInfo(id) {
  return request({
    url: "/admin/topic/get/".concat(id),
    method: "get"
  });
}; // 保存专题

export var hallSaveOrUpdate = function hallSaveOrUpdate(data) {
  return request({
    url: "/admin/topic/saveOrUpdate",
    method: "post",
    data: qs.stringify(data)
  });
}; // 首页-办事服务列表

export var getTopicDlList = function getTopicDlList(params) {
  return request({
    url: "/admin/home/getServeList",
    method: "get",
    params: params
  });
}; // 首页-应用中心列表

export var getSubjectDlList = function getSubjectDlList(params) {
  return request({
    url: "/admin/home/getAppList",
    method: "get",
    params: params
  });
}; // 首页-卡片列表

export var getCardList = function getCardList(params) {
  return request({
    url: "/admin/home/getInformationList",
    method: "get",
    params: params
  });
};